import { graphql } from 'gatsby';
import * as React from 'react';
import { Box, ServiceBoxTitle } from '../components/Box';
import { Container } from '../components/Container';
import { Facebook } from '../components/Facebook';
import { SocialServiceIconType } from '../components/Icon';
import { PrimaryLink } from '../components/Link';
import {
  ArticleDate,
  ArticleHeader,
  ArticleHeaderTitle,
  ArticlePreamble,
  ArticleTop,
  NewsSummaryList,
  NewsSummery,
  NewsWrapper,
  SocialMediaBox,
  SocialMediaBoxes
} from '../components/Sections';
import { IDefaultPropsWithData } from '../IDefaultProps';
import { Base } from '../layouts/Base';
import {
  ContentfulNews,
  ContentfulSocialService
} from '../types/graphql-types';
import { GetLinkFromId } from '../utils/getLinkFromId';
import { SEO } from '../utils/seo';
import { getTranslations } from '../utils/translations';

export default ({ data }: IDefaultPropsWithData) => {
  const translations = getTranslations(data);
  return (
    <Base>
      <SEO
        title={data.contentfulPage!.name as string}
        description={
          (data.contentfulPage!.preamble &&
            (data.contentfulPage!.preamble!.childContentfulRichText!
              .html as string)) ||
          undefined
        }
      />
      <Container>
        <NewsWrapper>
          <ArticleTop>
            {data.contentfulPage!.name && (
              <Box>
                <ServiceBoxTitle>{data.contentfulPage!.name}</ServiceBoxTitle>
              </Box>
            )}
            <ArticleHeader>
              <NewsSummaryList>
                {getNodes<ContentfulNews>(data.allContentfulNews).map(node => (
                  <NewsSummery key={node.id}>
                    <ArticleHeaderTitle>{node.name}</ArticleHeaderTitle>
                    <ArticleDate>
                      {new Date(node.createdAt).toLocaleDateString()}
                    </ArticleDate>
                    {node.preamble && (
                      <ArticlePreamble
                        dangerouslySetInnerHTML={{
                          __html: node.preamble!.childContentfulRichText!
                            .html as string
                        }}
                      />
                    )}
                    {GetLinkFromId(node.id) && (
                      <PrimaryLink
                        bold={true}
                        to={GetLinkFromId(node.id) as string}
                      >
                        {translations.get('ReadMore')}
                      </PrimaryLink>
                    )}
                  </NewsSummery>
                ))}
              </NewsSummaryList>
            </ArticleHeader>
          </ArticleTop>
          <SocialMediaBoxes>
            {getNodes<ContentfulSocialService>(
              data.allContentfulSocialService
            ).map(node => {
              if (node.icon === SocialServiceIconType.Facebook) {
                return (
                  <SocialMediaBox key={node.icon}>
                    <Facebook appId={node!.appId!} url={node!.url!} />
                  </SocialMediaBox>
                );
              }
            })}
          </SocialMediaBoxes>
        </NewsWrapper>
      </Container>
    </Base>
  );
};

const getNodes = <TNode extends {}>(collection: any) =>
  collection.edges.map((edge: any) => edge.node) as TNode[];

export const query = graphql`
  query($id: String!, $locale: String!) {
    allContentfulNews(
      filter: { name: { ne: null }, node_locale: { eq: $locale } }
      sort: { fields: [createdAt], order: DESC }
    ) {
      edges {
        node {
          id
          name
          createdAt
          preamble {
            childContentfulRichText {
              html
            }
          }
        }
      }
    }
    contentfulPage(id: { eq: $id }) {
      name
      preamble {
        childContentfulRichText {
          html
        }
      }
    }
    allContentfulSocialService(
      filter: { appId: { ne: null }, node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          icon
          appId
          url
        }
      }
    }
    allContentfulTranslation(
      filter: { key: { in: ["ReadMore"] }, node_locale: { eq: $locale } }
    ) {
      edges {
        node {
          key
          value
        }
      }
    }
  }
`;
